import { Injectable } from '@angular/core';
import { SocketEvent } from '@model/socket-event';
import { Observable, Subject, fromEvent } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { LocalSettingsKey } from '@shared/types/local-settings';

@Injectable({
    providedIn: 'root'
})
export class SocketEventStorage {
    socketMessageEventDataRefresher = new Subject<SocketEvent[]>();
    socketMessageAndConversationEventDataRefresher = new Subject<SocketEvent[]>();
    socketFolderEventDataRefresher = new Subject<SocketEvent[]>();
    socketContactEventDataRefresher = new Subject<SocketEvent[]>();
    socketCalendarEventDataRefresher = new Subject<SocketEvent[]>();
    quickEventDataRefresher = new Subject<SocketEvent[]>();

    constructor() { }

    refreshSocketMailEventInfo(events: SocketEvent[]) {
        this.socketMessageEventDataRefresher.next(events);
    }

    getSocketMailEventInfoRefresher(): Observable<SocketEvent[]> {
        return this.socketMessageEventDataRefresher.asObservable();
    }

    refreshSocketMailAndConversationEventInfo(events: SocketEvent[]) {
        this.socketMessageAndConversationEventDataRefresher.next(events);
    }

    getSocketMailAndConversationEventInfoRefresher(): Observable<SocketEvent[]> {
        return this.socketMessageAndConversationEventDataRefresher.asObservable();
    }

    refreshSocketFolderEventInfo(events: SocketEvent[]) {
        this.socketFolderEventDataRefresher.next(events);
    }

    getSocketFolderEventInfoRefresher(): Observable<SocketEvent[]> {
        return this.socketFolderEventDataRefresher.asObservable();
    }

    refreshSocketContactEventInfo(events: SocketEvent[]) {
        this.socketContactEventDataRefresher.next(events);
    }

    getSocketContactEventInfoRefresher(): Observable<SocketEvent[]> {
        return this.socketContactEventDataRefresher.asObservable();
    }

    refreshSocketCalendarEventInfo(events: SocketEvent[]) {
        this.socketCalendarEventDataRefresher.next(events);
    }

    getSocketCalendarEventInfoRefresher(): Observable<SocketEvent[]> {
        return this.socketCalendarEventDataRefresher.asObservable();
    }

    refreshQuickEventInfo(events: SocketEvent[]) {
        this.quickEventDataRefresher.next(events);
    }

    getQuickEventInfoRefresher(): Observable<SocketEvent[]> {
        return this.quickEventDataRefresher.asObservable();
    }

    setPopoutMailEvents(events: SocketEvent[]): void {
        localStorage.setItem(LocalSettingsKey.POPOUT_EVENT, JSON.stringify(events));
        localStorage.removeItem(LocalSettingsKey.POPOUT_EVENT);
    }

    listenPopoutEvents(): Observable<string> {
        return fromEvent<StorageEvent>(window, 'storage').pipe(
            filter(event => event.key === LocalSettingsKey.POPOUT_EVENT),
            map(event => event.newValue)
        );
    }
}
